module.exports = __webpack_public_path__ + "images/peeping-tom-4e5b5ad72ffd3d27a9af39a0b0c07413.png";